export default __webpack_public_path__ + "static/media/waving.001f9b27.png";